import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'index',
            component: resolve => require(['@/components/index'], resolve)
        },
        {
            path: '/en',
            name: 'en',
            component: resolve => require(['@/components/en'], resolve)
        },
        {
            path: '/zongshu',
            name: 'zongshu',
            component: resolve => require(['@/components/zongshu'], resolve)
        },
        {
            path: '/zongshuEn',
            name: 'zongshuEn',
            component: resolve => require(['@/components/zongshuEn'], resolve)
        },
        {
            path: '/cap',
            name: 'cap',
            component: resolve => require(['@/components/cap'], resolve)
        },
        {
            path: '/capEn',
            name: 'capEn',
            component: resolve => require(['@/components/capEn'], resolve)
        },
        {
            path: '/sjze',
            name: 'sjze',
            component: resolve => require(['@/components/sjze'], resolve)
        },
        {
            path: '/sjzeEn',
            name: 'sjzeEn',
            component: resolve => require(['@/components/sjzeEn'], resolve)
        },
        {
            path: '/szzl',
            name: 'szzl',
            component: resolve => require(['@/components/szzl'], resolve)
        },
        {
            path: '/potential',
            name: 'potential',
            component: resolve => require(['@/components/potential'], resolve)
        },
        {
            path: '/szzlEn',
            name: 'szzlEn',
            component: resolve => require(['@/components/szzlEn'], resolve)
        },
        {
            path: '/sector',
            name: 'sector',
            component: resolve => require(['@/components/sector'], resolve)
        },
        {
            path: '/sectorEn',
            name: 'sectorEn',
            component: resolve => require(['@/components/sectorEn'], resolve)
        },
        {
            path: '/download',
            name: 'download',
            component: resolve => require(['@/components/download'], resolve)
        },
        {
            path: '/downloadEn',
            name: 'downloadEn',
            component: resolve => require(['@/components/downloadEn'], resolve)
        },
        {
            path: '/company/:id',
            name: 'company',
            component: resolve => require(['@/components/company'], resolve)
        },
        {
            path: '/companyEn/:id',
            name: 'companyEn',
            component: resolve => require(['@/components/companyEn'], resolve)
        },
        {
            path: '/copyright',
            name: 'copyright',
            component: resolve => require(['@/components/copyright'], resolve)
        },
        {
            path: '/copyrightEn',
            name: 'copyrightEn',
            component: resolve => require(['@/components/copyrightEn'], resolve)
        },
        {
            path: '/organization',
            name: 'organization',
            component: resolve => require(['@/components/organization'], resolve)
        },
        {
            path: '/organizationEn',
            name: 'organizationEn',
            component: resolve => require(['@/components/organizationEn'], resolve)
        },
        {
            path: '/contact',
            name: 'contact',
            component: resolve => require(['@/components/contact'], resolve)
        },
        {
            path: '/contactEn',
            name: 'contactEn',
            component: resolve => require(['@/components/contactEn'], resolve)
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js